export default "__VITE_ASSET___5kjNNWs__"